import React from 'react';
import Modal from '../Modal';
import closeBtn from './close-btn.svg';
import PropTypes from 'prop-types';
import './styles.css';

const ImmersiveTourModal = (props) => {
  return (
    <Modal
      injectedStyles={{
        content: {
          background: '#000',
          border: 'none',
          padding: 0,
          height: '100%',
          width: '100%'
        },
        overlay: { background: '#333333E5' }
      }}
      isOpen={props.isOpen}
      onRequestClose={props.closeModal}
      portalClassName="virtual-tour-modal"
    >
      <div className="modal-container" data-testid="immersive-tour-modal">
        <header>
          <h2>{props.title}</h2>
          <button
            id="close-virtual-tour"
            className="close-btn"
            onClick={ props.closeModal }
          >
            <img src={closeBtn} />
            <span className="visuallyhidden">Close Modal</span>
          </button>
        </header>
        <iframe
          id="virtual-tour-content"
          src={props.url}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
        />
      </div>
    </Modal>
  );
};

ImmersiveTourModal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

export default ImmersiveTourModal;
